import { Button, Modal } from "@mui/material";
import React from "react";
import styled from "styled-components";

export default function ErrorModal({
  open,
  onClose,
  message,
  buttonText,
  onButtonClick,
  onCloseClick,
}) {
  if (!open) return null;

  const handleClose = () => {
    if (onCloseClick) onCloseClick();
    if (onClose) onClose();
  };

  const handleButtonClick = () => {
    if (onButtonClick) onButtonClick();
    if (onClose) onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="export-limit-modal-title"
      aria-describedby="export-limit-modal-description"
    >
      <ModalRejector>
        <ModalClose
          src="/img/modal_close.svg"
          onClick={handleClose}
          alt="Fechar"
        />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 24,
            marginTop: 24,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M12.5 8.00002V12M12.5 16H12.51M3.5 7.94147V16.0586C3.5 16.4012 3.5 16.5725 3.55048 16.7253C3.59515 16.8605 3.66816 16.9846 3.76463 17.0893C3.87369 17.2076 4.02345 17.2908 4.32297 17.4572L11.723 21.5683C12.0066 21.7259 12.1484 21.8047 12.2985 21.8356C12.4315 21.8629 12.5685 21.8629 12.7015 21.8356C12.8516 21.8047 12.9934 21.7259 13.277 21.5683L20.677 17.4572C20.9766 17.2908 21.1263 17.2076 21.2354 17.0893C21.3318 16.9846 21.4049 16.8605 21.4495 16.7253C21.5 16.5725 21.5 16.4012 21.5 16.0586V7.94147C21.5 7.59883 21.5 7.4275 21.4495 7.27471C21.4049 7.13953 21.3318 7.01545 21.2354 6.91076C21.1263 6.79242 20.9766 6.70922 20.677 6.54282L13.277 2.43171C12.9934 2.27415 12.8516 2.19537 12.7015 2.16448C12.5685 2.13715 12.4315 2.13715 12.2985 2.16448C12.1484 2.19537 12.0066 2.27415 11.723 2.43171L4.32297 6.54282C4.02345 6.70922 3.87369 6.79242 3.76463 6.91076C3.66816 7.01545 3.59515 7.13953 3.55048 7.27471C3.5 7.4275 3.5 7.59883 3.5 7.94147Z"
              stroke="#CA1C1C"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div style={{ textAlign: "center", margin: "24px 0" }}>
          <MessageText>{message || 'Ops! Ocorreu um problema. Tente novamente mais tarde.'}</MessageText>
          <Button
            variant="contained"
            color="primary"
            onClick={handleButtonClick}
            style={{
              marginBottom: "10px",
              width: "100%",
              height: "3rem",
              color: "#000",
              fontWeight: "600",
            }}
          >
            {buttonText || 'OK'}
          </Button>
        </div>
      </ModalRejector>
    </Modal>
  );
}

const ModalRejector = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 430px;
  height: auto;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px solid rgb(144, 144, 144);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
  padding: 20px;
`;
const MessageText = styled.p`
  font-size: 16px;
  margin-bottom: 30px;
  color: #181122;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
  white-space: pre-line;
  text-transform: uppercase;
`;

const ModalClose = styled.img`
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;
